export default __webpack_public_path__ + "static/media/Slider_1500_Web.1f7dca8c.webp";